<div class="wrapper">
  <a
    class="sidebar-button"
    [attr.data-analytics]="name + '-sidebar-button'"
    [class.sidebar-button-active]="selected"
    [routerLink]="buttonMapping[name].link"
  >
    @if (notificationDotVisible) {
      <app-notification-dot
        color="red"
        top="15px"
        right="25px"
      />
    }
    @if (buttonMapping[name].iconSrc) {
      <img
        alt=""
        class="sidebar-button-icon"
        [src]="buttonMapping[name].iconSrc"
      />
    } @else {
      <mat-icon class="material-icons-outlined">
        {{ buttonMapping[name].icon }}
      </mat-icon>
    }
    <div class="sidebar-button-text">
      {{ buttonMapping[name].text }}
    </div>
  </a>
</div>
